import { Link } from 'react-router-dom';

import OrderHeader from './OrderHeader';
import OrderAddress from './OrderAddress';
import OrderDates from './OrderDates';
import OrderResume from './OrderResume';

const OrderSummary = ({ summary, ICMSST }) => {
  const {
    number,
    orderStatus,
    customer,
    customerEmail,
    customerPhone,
    registrationNumber,
    stateRegistrationNumber,
    creationDate,
    minDeliveryEstimatedDate,
    maxDeliveryEstimatedDate,
    shippingAddress,
    totalPrice,
    shippingCostInventa,
    isNewCustomer,
    registrationType,
    totalTaxes,
    estimatedTaxes,
    estimatedShippingCost,
    source,
    takeRate,
    takeRateValue,
    netValue,
    additionalAdjustment,
    discounts,
    fees,
  } = summary;

  return (
    <>
      <div className="row">
        <div className="col-6">
          <Link to="/pedido" className="change-link">
            <span>
              <i className="fas fa-arrow-left" aria-hidden="true" /> voltar
            </span>
          </Link>
        </div>
      </div>
      <OrderHeader
        number={number}
        orderStatus={orderStatus}
        customer={customer}
        source={source}
        registrationNumber={registrationNumber}
        resgistrationType={registrationType}
        stateRegistrationNumber={stateRegistrationNumber}
        isNewCustomer={isNewCustomer}
        email={customerEmail}
        phone={customerPhone}
      />
      <div className="row mb-4">
        <OrderDates
          creationDate={creationDate}
          minDeliveryEstimatedDate={minDeliveryEstimatedDate}
          maxDeliveryEstimatedDate={maxDeliveryEstimatedDate}
        />
        <OrderAddress shippingAddress={shippingAddress} />
        <OrderResume
          additionalAdjustment={additionalAdjustment}
          discounts={discounts}
          estimatedShippingCost={estimatedShippingCost}
          estimatedTaxes={estimatedTaxes}
          ICMSST={ICMSST}
          netValue={netValue}
          shippingCostInventa={shippingCostInventa}
          source={source}
          takeRate={takeRate}
          takeRateValue={takeRateValue}
          totalPrice={totalPrice}
          totalTaxes={totalTaxes}
          fees={fees}
        />
      </div>
    </>
  );
};

export default OrderSummary;
